import { render, staticRenderFns } from "./our-mission-and-our-values.vue?vue&type=template&id=68fcd351&"
import script from "./our-mission-and-our-values.vue?vue&type=script&lang=js&"
export * from "./our-mission-and-our-values.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports